import { render, staticRenderFns } from "./servicekeyscomponent.vue?vue&type=template&id=5983d565&"
import script from "./servicekeyscomponent.vue?vue&type=script&lang=ts&"
export * from "./servicekeyscomponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports